import { create } from 'zustand'
import { produce } from 'immer'

export const useChangelog = create((set) => ({
  data: {
    logs: [],
  },
  actions: {
    setLogs: (logs) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.logs = logs
        }),
      ),
  },
}))
